const AsyncDocumentType = {
  LABEL: "label",
  CONTENT_DECLARATION: "content-declaration",
  RECEIPT: "receipt",
  SHIPPING_DOCUMENT: "shipping-document",
} as const;

type AsyncDocumentType =
  typeof AsyncDocumentType[keyof typeof AsyncDocumentType];

export default AsyncDocumentType;
